import { createContext } from "react"

const FilterableSearchContext = createContext({result: undefined, setResult: undefined})

export default FilterableSearchContext;